import { ICatalogueListData, ICataloguesPage } from './types';

export const mockCataloguesList: ICatalogueListData[] = [
  {
    id: '1',
    name: 'Spring Specials',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2024-03-01',
    expiredDate: '2024-03-31',
    status: 'Active',
  },
  {
    id: '2',
    name: 'Summer Deals',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2024-06-01',
    expiredDate: '2024-06-30',
    status: 'Inactive',
  },
  {
    id: '3',
    name: 'Back to School',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2024-08-15',
    expiredDate: '2024-09-15',
    status: 'Active',
  },
  {
    id: '4',
    name: 'Autumn Offers',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2024-09-20',
    expiredDate: '2024-10-20',
    status: 'Revise',
  },
  {
    id: '5',
    name: 'Winter Warmers',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2024-12-01',
    expiredDate: '2024-12-31',
    status: 'Active',
  },
  {
    id: '6',
    name: 'Holiday Specials',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2024-12-15',
    expiredDate: '2025-01-05',
    status: 'Inactive',
  },
  {
    id: '7',
    name: 'New Year Bonanza',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2025-01-01',
    expiredDate: '2025-01-31',
    status: 'Pending',
  },
  {
    id: '8',
    name: "Valentine's Picks",
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2025-02-01',
    expiredDate: '2025-02-14',
    status: 'Pending',
  },
  {
    id: '9',
    name: 'Easter Eggs',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2025-03-20',
    expiredDate: '2025-04-05',
    status: 'Inactive',
  },
  {
    id: '10',
    name: 'Mega Sale',
    previewUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png',
    startDate: '2025-05-01',
    expiredDate: '2025-05-31',
    status: 'Declined',
    adminMessage: 'This catalogue has been declined due to policy violations.',
  },
];

export const mockCataloguePages: ICataloguesPage[] = [
  {
    id: 'f139d0ae-d84b-4440-a0a6-7fab5fad292f',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-1.png',
    position: 1,
    products: [],
  },
  {
    id: '8699fe2f-7071-40d4-bb13-7a80000f287f',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-2.png',
    position: 2,
    products: [],
  },
  {
    id: 'e0be5f84-c9b8-42d4-8027-437fd2331bfc',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-3.png',
    position: 3,
    products: [],
  },
  {
    id: '60f318dd-d4e3-4861-8770-ca47b07ef1f0',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-4.png',
    position: 4,
    products: [],
  },
  {
    id: 'b96a8a41-8fdd-4835-b267-a8b7b79832ca',
    imageUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    position: 5,
    products: [],
  },
  {
    id: 'b46530f8-42c0-41a2-a771-163905a3fbe6',
    imageUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/7ead8c9b9bd0a09ae65498ffb04538b3.png',
    position: 6,
    products: [],
  },
  {
    id: '7fbc9688-fa75-4871-a2ac-12cf56b5304f',
    imageUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/af9d76e7101bf7adf9fa9646ce71ce4c.png',
    position: 7,
    products: [],
  },
  {
    id: 'c12693f0-b891-4d26-ba02-9e20c8b53a16',
    imageUrl:
      'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8bea536aae301f1a3de6a29202c9da02.png',
    position: 8,
    products: [],
  },
];
